import i18n from 'i18next'

import { Language } from '../types/language'
import { LocaleIdentifier } from '../types/localeIdentifier'
import { languageToLocale } from './languageToLocale'

export const getCurrentLocale = (): LocaleIdentifier => {
  return languageToLocale[i18n.language as Language]
}
